import React from 'react'
import { Chip } from '@mui/material'

const STATUS_CONFIG = {
  open: { color: 'info', label: 'Aberto' },
  file: { color: 'warning', label: 'Gerando Laudo' },
  waiting: { color: 'secondary', label: 'Aguardando Assinatura' },
  signed: { color: 'success', label: 'Assinado' },
}

const InspectionStatusChip = ({ status }) => {
  const config = STATUS_CONFIG[status] || { color: 'default', label: status }
  return (
    <Chip
      size="small"
      variant="outlined"
      color={config.color}
      label={config.label}
    />
  )
}

export default InspectionStatusChip
